module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-dense"
  }, [_c('div', [_c('h1', {
    staticClass: "md-title",
    staticStyle: {
      "margin-right": "auto"
    }
  }, [_vm._v("List Grouper")]), _vm._v(" "), (!_vm.loading.upload) ? _c('md-button', {
    staticClass: "md-icon-button file-upload-button"
  }, [_c('md-icon', [_vm._v("file_upload")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "text/plain,application/json"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload($event.target.files[0])
      },
      "drop": function($event) {
        _vm.handleFileUpload($event.dataTransfer.files[0])
      }
    }
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Upload")])], 1) : _c('md-spinner')], 1), _vm._v(" "), _c('div', [_c('md-input-container', {
    attrs: {
      "md-inline": ""
    }
  }, [_c('md-input', {
    attrs: {
      "placeholder": "Untitled list"
    },
    on: {
      "change": function($event) {
        _vm.dirty = true;
      }
    },
    model: {
      value: (_vm.list.name),
      callback: function($$v) {
        _vm.list.name = $$v
      },
      expression: "list.name"
    }
  })], 1), _vm._v(" "), (!_vm.loading.save) ? _c('md-button', {
    staticClass: "md-icon-button",
    class: {
      'md-raised md-accent': _vm.dirty
    },
    nativeOn: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('md-icon', [_vm._v("call_merge")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Save")])], 1) : _c('md-spinner'), _vm._v(" "), (!_vm.loading.duplicate) ? _c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.save(true)
      }
    }
  }, [_c('md-icon', [_vm._v("call_split")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Duplicate")])], 1) : _c('md-spinner'), _vm._v(" "), (!_vm.loading.download) ? _c('md-menu', {
    attrs: {
      "md-size": "3"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("file_download")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Download")])], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.exportJson(_vm.uploadedFilename)
      }
    }
  }, [_c('md-icon', [_vm._v("file_download")]), _vm._v(" "), _c('span', [_vm._v("JSON")])], 1), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.exportCsv(_vm.uploadedFilename)
      }
    }
  }, [_c('md-icon', [_vm._v("file_download")]), _vm._v(" "), _c('span', [_vm._v("CSV")])], 1)], 1)], 1) : _c('md-spinner'), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-grow": "1"
    }
  }), _vm._v(" "), (_vm.meLoaded) ? _c('div', [(!_vm.me) ? _c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-1px",
      "margin-left": "-5px",
      "margin-right": "5px"
    },
    attrs: {
      "src": "/static/google-logo.svg",
      "alt": "Google",
      "width": "20"
    }
  }), _vm._v(" Login\n        ")]) : _c('div', [_c('md-menu', {
    attrs: {
      "md-size": "3"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-avatar', [_c('img', {
    attrs: {
      "src": _vm.me.photoURL,
      "role": "presentation"
    }
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Account")])], 1)], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('md-icon', [_vm._v("power_settings_new")]), _vm._v(" "), _c('span', [_vm._v("Logout")])], 1)], 1)], 1)], 1)], 1) : _c('md-spinner')], 1)]), _vm._v(" "), (_vm.list.data) ? _c('data-grouper', {
    ref: "dataGrouper",
    attrs: {
      "initial-list": _vm.list
    },
    on: {
      "dirty": function($event) {
        _vm.dirty = true;
      }
    }
  }) : _c('aside', [_c('div', [_vm._v("No data loaded.")])]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "loginConfirm",
    attrs: {
      "md-content-html": "You need to login first.",
      "md-ok-text": "Login",
      "md-cancel-text": "Cancel"
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom right"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("\n    Saved!\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b598348"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 261
// module chunks = 1